export function isFrameCheck(): boolean {
  if (window.self !== window.top) {
    return true;
  } else {
    return false;
  }
}
